<template>
  <div class="forgot-password-page">
    <!-- Forgot Password Section -->
    <section class="forgot-password-section">
      <div class="login-background">
        <img :src="Images.login.background" alt="Background" class="login-bg-image">
      </div>
      <div class="login-container">
        <div class="login-form forgot-password-form">

          <!-- 忘记密码表单 -->
          <div v-if="currentStep < 3" class="step-content">
            <div class="header-container">
              <button class="back-button-icon" @click="goBack">←</button>
              <h2 class="login-title">忘记密码</h2>
            </div>
            <!-- 身份验证部分 -->
            <div class="form-group">
              <input type="number" class="form-input" v-model="formData.phone" placeholder="手机号" required>
            </div>
            <div class="form-group">
              <div class="captcha-container">
                <input type="text" class="form-input captcha-input" v-model="formData.captcha" placeholder="图形验证码" required>
                <div class="captcha-image" @click="generateCaptcha">{{ captchaCode }}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="verification-code">
                <input type="number" class="form-input code-input" v-model="formData.verificationCode" placeholder="验证码" required>
                <button class="send-code-button" @click="sendVerificationCode" :disabled="countdown > 0">
                  {{ countdown > 0 ? `${countdown}秒后重发` : '发送验证码' }}
                </button>
              </div>
            </div>
            <!-- 设置新密码部分 -->
            <div class="form-group">
              <input type="password" class="form-input" v-model="formData.newPassword" placeholder="请输入新密码(至少八位，且包含字母数字)" required>
            </div>
            <div class="form-group">
              <input type="password" class="form-input" v-model="formData.confirmPassword" placeholder="请再次输入密码" required>
            </div>
            <div class="form-buttons">
              <button class="login-button" @click="resetPassword">重置密码</button>
            </div>
          </div>

          <!-- 重置密码成功 -->
          <div v-if="currentStep === 3" class="step-content complete-step">
            <h2 class="login-title">重置密码成功</h2>
            <div class="success-icon">
              <div class="check-circle">✓</div>
            </div>
            <button class="login-button" @click="goToLogin">立即登录</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Images } from '@/utils/imageLoader';
import { userApi } from '@/utils/api';

export default {
  name: 'ForgotPasswordView',
  data() {
    return {
      currentStep: 1,
      Images,
      countdown: 0,
      countdownTimer: null,
      captchaCode: '',
      formData: {
        account: '',
        captcha: '',
        phone: '',
        verificationCode: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  methods: {
    // 下一步
    nextStep() {
      // 表单验证
      if (!this.validateCurrentStep()) {
        return;
      }

      // 进入下一步
      if (this.currentStep < 4) {
        this.currentStep++;
      }
    },

    // 上一步
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },

    // 验证当前步骤
    validateCurrentStep() {
      // 验证手机号
      if (!this.formData.phone) { 
        alert('请输入手机号码');
        return false;
      }
      // 身份验证步骤，需要验证手机号格式
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.formData.phone)) {  
        alert('请输入正确的手机号');
        return false;
      }
      // 验证图形验证码
      if (!this.formData.captcha) {
        alert('请输入图形验证码');
        return false;
      }
      if (this.formData.captcha !== this.captchaCode) {
        alert('图形验证码错误');
        return false;
      }
      // 验证手机验证码
      if (!this.formData.verificationCode) {
        alert('请输入验证码');
        return false;
      }
      if (this.formData.verificationCode.toString().length !== 6) {
        alert('验证码为6位数字');
        return false;
      }
      // 验证新密码
      if (!this.formData.newPassword) {
        alert('请输入新密码');
        return false;
      }
      if (this.formData.newPassword.length < 8) {
        alert('密码长度至少8位');
        return false;
      }
      // 验证确认密码
      if (!this.formData.confirmPassword) {
        alert('请确认新密码');
        return false;
      }
      if (this.formData.newPassword !== this.formData.confirmPassword) {
        alert('两次输入的密码不一致');
        return false;
      }
      return true;
    },

    // 发送验证码
    sendVerificationCode() {
      console.log('sendVerificationCode方法被调用');
      console.log('调用时间:', new Date().toISOString());
      
      if (!this.formData.phone) {
        alert('请输入手机号码');
        return;
      }

      // 假设用户输入的账号信息是手机号
      const phone = this.formData.phone;
      if (phone.toString().length !== 11) {
        alert('请输入正确的手机号');
        return;
      }

      // 校验图像验证码
      if (!this.formData.captcha) {
        alert('请输入图形验证码');
        return;
      }
      if (this.formData.captcha !== this.captchaCode) {
        alert('图形验证码错误');
        return;
      }

      // 调用API发送验证码
      console.log('准备调用API发送验证码:', phone, 5);
      userApi.sendVerificationCode(phone, 5) // 假设type=3是忘记密码
        .then(data => {
          console.log('验证码发送成功:', data);
          alert('验证码发送成功');
          // 开始倒计时
          this.startCountdown();
        })
        .catch(error => {
          console.error('验证码发送失败:', error);
          console.error('错误详情:', error);
          alert('验证码发送失败: ' + (error.msg || '请稍后重试'));
        });
    },

    // 开始倒计时
    startCountdown() {
      this.countdown = 60;
      
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },

    // 重置密码
    resetPassword() {
      // 表单验证
      if (!this.validateCurrentStep()) {
        return;
      }

      // 准备重置密码数据
      const resetData = {
        phone: this.formData.phone,
        code: this.formData.verificationCode,
        password: this.formData.newPassword
      };

      // 调用API重置密码
      userApi.resetPassword(resetData)
        .then(data => {
          console.log('重置密码成功:', data);
          // 进入完成步骤
          this.currentStep = 3;
        })
        .catch(error => {
          console.error('重置密码失败:', error);
          alert('重置密码失败: ' + (error.msg || '请稍后重试'));
        });
    },

    // 跳转到登录页面
    goToLogin() {
      this.$router.push('/login');
    },

    // 返回上一级
    goBack() {
      this.$router.back();
    },

    // 生成随机验证码
    generateCaptcha() {
      const chars = '0123456789';
      let code = '';
      for (let i = 0; i < 4; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      this.captchaCode = code;
    }
  },
  mounted() {
    // 生成初始验证码
    this.generateCaptcha();
  },
  beforeUnmount() {
    // 清理定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }
}
</script>

<style scoped>
.forgot-password-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.forgot-password-section {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px 0 80px;
  position: relative;
  flex: 1;
}

.login-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1;
}

.login-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.login-container {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.forgot-password-form {
  background-color: white;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 500px;
}

/* Progress Steps */
.progress-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
  position: relative;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
  transition: all 0.3s;
}

.step-text {
  font-size: 12px;
  color: #999;
  transition: all 0.3s;
}

.step.active .step-number {
  background-color: #ff6b00;
  color: white;
}

.step.active .step-text {
  color: #ff6b00;
  font-weight: 500;
}

.step.completed .step-number {
  background-color: #ff6b00;
  color: white;
}

.step.completed .step-text {
  color: #333;
}

/* Header Container */
.header-container {
  position: relative;
  margin-bottom: 30px;
  height: 40px;
  display: flex;
  align-items: center;
}

.login-title {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 50%;
  transform: translate(-50%, -50%);
}

/* Back Button Icon */
.back-button-icon {
  width: 40px;
  height: 40px;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  background-color: white;
  color: #666;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  z-index: 1;
}

.back-button-icon:hover {
  border-color: #ff6b00;
  color: #ff6b00;
  box-shadow: 0 2px 8px rgba(255, 107, 0, 0.1);
}

/* Form Styles */

.form-group {
  margin-bottom: 20px;
}

.form-input {
  width: 100%;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s;
}

.form-input:focus {
  border-color: #ff6b00;
}

/* Captcha Styles */
.captcha-container {
  display: flex;
  gap: 10px;
  align-items: center;
}

.captcha-input {
  flex: 1;
}

.captcha-image {
  width: 100px;
  height: 48px;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
}

.captcha-image:hover {
  background-color: #e8e8e8;
}

/* Verification Code Styles */
.verification-code {
  display: flex;
  gap: 10px;
  align-items: center;
}

.code-input {
  flex: 1;
}

.send-code-button {
  padding: 12px 20px;
  background-color: #ff6b00;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.send-code-button:hover {
  background-color: #ff8533;
}

.send-code-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Button Styles */
.login-button {
  width: 100%;
  padding: 12px;
  background-color: #ff6b00;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 20px;
} 

.login-button:hover {
  background-color: #ff8533;
}

.form-buttons {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.back-button {
  flex: 1;
  padding: 12px;
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.back-button:hover {
  background-color: #e8e8e8;
}

/* Complete Step Styles */
.complete-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.success-icon {
  margin: 40px 0;
}

.check-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #4caf50;
  color: white;
  font-size: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pulse 1s ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}

/* Remove number input spin buttons */
.forgot-password-form input[type=number]::-webkit-inner-spin-button,
.forgot-password-form input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.forgot-password-form input[type=number] {
  -moz-appearance: textfield;
}
</style>